// Owner: workflow-inspector (plan §9.34, §3.1). `/automations/runs`: the run explorer across
// automations; filters live in the URL.
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { RUN_STATUSES } from '@dataroom/core/search-enums';
import { RunsExplorerPage } from '../../../features/workflows/runs/RunsExplorerPage';

const Search = z.object({
  status: z.enum(RUN_STATUSES).optional().catch(undefined),
  workflow: z.string().max(2000).optional().catch(undefined),
  kind: z.enum(['real', 'test', 'all']).optional().catch(undefined),
  period: z.enum(['24h', '7d', '30d', 'all']).optional().catch(undefined),
  record: z.string().max(200).optional().catch(undefined),
  version: z.coerce.number().int().min(1).optional().catch(undefined),
  error: z.string().max(120).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/automations/runs')({
  validateSearch: Search,
  component: RunsRoute,
});

function RunsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RunsExplorerPage search={search} onSearch={(next) => void navigate({ search: next, replace: true })} />
  );
}
